module.exports = __webpack_public_path__ + "img/12453-New ESP TM.4a7a1de8.png";